import { AfterViewInit, Component } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { CookieService } from "ngx-cookie-service";
import { environment } from "src/environments/environment";
import { UIService } from "./shared/services/ui/ui.service";
import videojs from "video.js";

import * as videojsPL from "video.js/dist/lang/pl.json";
import { JiraWidgetService } from "./shared/services/jira-widget/jira-widget.service";
import { WarningModalService } from "./shared/services/warning-modal/warning-modal.service";

@Component({
  selector: "root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements AfterViewInit {
  private static readonly SESSION_REVOKED_MODAL_STORAGE_KEY =
    "cyber-skiller-session-revoked-modal";

  title = "CyberSkiller";

  constructor(
    private translate: TranslateService,
    private cookieService: CookieService,
    private jiraWidget: JiraWidgetService,
    private warningModalService: WarningModalService,
  ) {
    translate.setDefaultLang(environment.defaultLang);
    this.getCookiesLang();
    // this.helpWidget.destroyWidget();
    // this.helpWidget.bootWidget();
    // this.helpWidget.hideWidget();
    UIService.setCSSContainers();
    videojs.addLanguage("pl", { ...videojsPL, Quality: "Jakość" });
  }

  ngAfterViewInit(): void {
    this.jiraWidget.injectDataToWidget();
    this.showSessionRevokedModalIfNeeded();
  }

  private getCookiesLang() {
    let lang: string = this.cookieService.get("cyber-skiller-lang");

    if (lang) {
      this.translate.use(lang);
    } else {
      this.translate.use(environment.defaultLang);
    }
  }

  private showSessionRevokedModalIfNeeded(): void {
    if (
      window.sessionStorage.getItem(
        AppComponent.SESSION_REVOKED_MODAL_STORAGE_KEY,
      ) !== "1"
    ) {
      return;
    }

    window.sessionStorage.removeItem(
      AppComponent.SESSION_REVOKED_MODAL_STORAGE_KEY,
    );

    this.warningModalService.showModal({
      modalTitle: "GLOBAL.MESSAGES.SESSION_REVOKED_TITLE",
      text: "GLOBAL.MESSAGES.SESSION_REVOKED_TEXT",
    });
  }
}
